import type { FC } from 'react';
import { useTranslation } from '../../../utils/useTranslation';
import { DialogContent, DialogFooter, DialogTitle } from '../../feedback/Dialog';
import { Flex } from '../../layout/Flex';
import { Typography } from '../../typography/Typography';
import { MODAL_WIDTH_DESKTOP, MODAL_WIDTH_TOUCH } from './constants';
import { ProductRemoveFormButton, ProductRemoveFormDialog } from './styles';
import { ProductRemoveFormProps } from './types';

export const ProductRemoveForm: FC<ProductRemoveFormProps> = ({ onClose, onRemove }) => {
    const t = useTranslation();

    return (
        <ProductRemoveFormDialog
            onClose={onClose}
            maxWidth={{ xs: MODAL_WIDTH_TOUCH, sm: MODAL_WIDTH_DESKTOP }}
        >
            <DialogTitle onClose={onClose} py={2} px={2} withBorderBottom={false} hideCloseButton>
                <Typography variant="title3" weight="bold" mr="auto">
                    {t('Удалить товар')}
                </Typography>
            </DialogTitle>
            <DialogContent py={2} px={2} height="auto">
                <Typography variant="body">
                    {t('Вы уверены, что хотите удалить этот товар?')}
                </Typography>
            </DialogContent>
            <DialogFooter withBorderTop={false} py={2} px={2}>
                <Flex direction="row" width="100%">
                    <ProductRemoveFormButton color="secondary" onClick={onRemove}>
                        {t('удалить')}
                    </ProductRemoveFormButton>
                    <ProductRemoveFormButton color="primary" marginLeft={1} onClick={onClose}>
                        {t('отмена')}
                    </ProductRemoveFormButton>
                </Flex>
            </DialogFooter>
        </ProductRemoveFormDialog>
    );
};
